import { withErrorBoundary } from 'app/components/error-boundary';
import { OpenSettingsPrompt, useOpenSettingsPrompt } from 'app/components/open-settings-prompt';
import { Page } from 'app/design/primitives/page';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { useNavigationOptions } from 'app/hooks/navigation';
import type { NavigationScreen } from 'app/types/navigation';
import { usePageTitle } from 'app/utils/web-helpers';
import React, { useEffect } from 'react';
import { NotificationPreferences } from './preferences';

const NotificationsSettingScreenComponent: NavigationScreen<'notifications-setting'> = ({ navigation }) => {
  const { t } = useScopedTranslation();

  useNavigationOptions(
    navigation,
    {
      headerTitle: () => (
        <Text variant="bodyXLargeMedium" color="white-label.header.on-header">
          {t('title')}
        </Text>
      ),
    },
    false,
  );
  const setPageTitle = usePageTitle('notifications-setting');
  useEffect(() => setPageTitle('title'), [setPageTitle]);

  const { isSettingsPromptOpen, openSettingsPrompt, closeSettingsPrompt } = useOpenSettingsPrompt();

  return (
    <Page>
      <NotificationPreferences openSettingsPrompt={openSettingsPrompt} />

      <OpenSettingsPrompt isOpen={isSettingsPromptOpen} onClose={closeSettingsPrompt} settingName="notification" />
    </Page>
  );
};

export const NotificationsSettingScreen: NavigationScreen<'notifications-setting'> = withErrorBoundary(
  NotificationsSettingScreenComponent,
);
